module.exports = __webpack_public_path__ + "img/poster.47b9a72d.png";